<div class="profile flex__child--auto flex--column has-toolbar" data-test="settings">
  <mat-toolbar>
    <span class="mat-toolbar__title text--primary">{{ 'settings.title' | translate }}</span>
  </mat-toolbar>
  <app-settings-navigation></app-settings-navigation>
  <div>
    <router-outlet #o="outlet"></router-outlet>
  </div>
</div>
